import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { ActivitySource } from './ActivitySource';
import { Book } from './Book';
import { Company } from './Company';
import { Content } from './Content';
import { CourseSection } from './CourseSection';
import { Edition } from './Edition';
import { Enrollment } from './Enrollment';
import { FileProfile } from './FileProfile';
import { HighlightColor } from './HighlightColor';
import { Item } from './Item';
import { Person } from './Person';
import { Product } from './Product';
import { Term } from './Term';

export enum NoteType {
  NOTE = 'NOTE',
  HIGHLIGHT = 'HIGHLIGHT',
  TRANSLATION = 'TRANSLATION',
  SUMMARY = 'SUMMARY',
}

export interface Note extends Item {
  personId: number;
  person?: Person;

  publisherId?: number;
  publisher?: Company;

  bookId?: number;
  book?: Book;

  editionId?: number;
  edition?: Edition;

  contentId?: number;
  content?: Content;

  schoolId?: number;
  school?: Company;

  termId?: number;
  term?: Term;

  courseSectionId?: number;
  courseSection?: CourseSection;

  productId?: number;
  product?: Product;

  enrollmentId?: number;
  enrollment?: Enrollment;

  text?: string;
  highlight?: string;

  chapterId?: number;
  pageId?: number;
  document?: string;
  anchorId?: string;
  anchorOffset?: number;
  focusId?: string;
  focusOffset?: number;
  color: HighlightColor;
  source: ActivitySource;

  anchorTextIndex?: number;
  focusTextIndex?: number;

  videos: FileProfile[];
  contentIds: number[];

  type: NoteType;
}

export const translateNoteForTransport = (attributes: any): any => {
  const response = { ...attributes };

  if (attributes.text) {
    response.text = !isBase64(attributes.text) ? base64Encode(attributes.text) : attributes.text;
  }

  return response;
};

export const translateNoteFromTransport = (attributes: any): any => {
  const response = { ...attributes };

  if (attributes.text) {
    response.text = isBase64(attributes.text) ? base64Decode(attributes.text) : attributes.text;
  }

  return response;
};
